import { supertypeClass, property } from '@haventech/amorphic';
import { Controller } from '../Controller';
import {
    AccountCenterControllerInterface
} from '../../../../coverpath-common/angular/interfaces/account-center/AccountCenterControllerInterface';
import { PaymentInformation } from '../../../../coverpath-common/classes/PaymentInformation';
import { AMCController } from '../../../../common/js/authentication/amc/AMCController';
import { InitialInvoice } from '../../../../common/js/policyAdmin/interface/InitialInvoiceInfoResponse';
import { MMDirectCustomer } from '../../../../coverpath-common/classes/mmdirect_subclasses/MMDirectCustomer';
import {
    CoverpathBaseAccountCenterController
} from '../../../../coverpath-common/js/controllers/CoverpathBaseAccountCenterController';
import { MMDirectApplication } from '../../../../coverpath-common/classes/mmdirect_subclasses/MMDirectApplication';

@supertypeClass({toClient: true, toServer: true})
export class AccountCenterController extends CoverpathBaseAccountCenterController implements AccountCenterControllerInterface {

    @property({getType: () => Controller})
    controller: Controller;

    constructor() {
        super();
        this.paymentInformation = PaymentInformation.new();
    }

    static new(parentController): AccountCenterController {
        return new AccountCenterController().init(parentController);
    }

    init(parentController): this {
        this.controller = parentController;
        return this;
    }

    getPath(): string {
        return 'mm-direct';
    }

    getController(): Controller {
        return this.controller;
    }

    getAMCController(): AMCController {
        return this.controller.getAMCController();
    }

    getApplication(): MMDirectApplication {
        return this.controller.customer.application;
    }

    getCustomer(): MMDirectCustomer {
        return this.controller.customer;
    }

    async getInitialInvoiceInfo(policyNumber: string): Promise<InitialInvoice> {
        return;
    }

    getAppLevelAmorphicTransaction() {
        return undefined;
    }
}
